require("!!/home/ubuntu/jenkins/workspace/7_9_Build/flavor/Pro/label_exp/docker-ec2-cloud/tmp/sugarbuild/sugarcrm/sidecar/node_modules/script-loader/addScript.js")(require("!!/home/ubuntu/jenkins/workspace/7_9_Build/flavor/Pro/label_exp/docker-ec2-cloud/tmp/sugarbuild/sugarcrm/sidecar/node_modules/raw-loader/index.js!/home/ubuntu/jenkins/workspace/7_9_Build/flavor/Pro/label_exp/docker-ec2-cloud/tmp/sugarbuild/sugarcrm/sidecar/lib/php-js/version_compare.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./lib/php-js/version_compare.js
// module id = 27
// module chunks = 0